import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/ThumbnailCard/sgds-thumbnail-card";
import { register } from "../../utils/ce-registry";

register("sgds-thumbnail-card", Component);

export default createComponent({
  react: React,
  tagName: "sgds-thumbnail-card",
  elementClass: Component,
  events: {}
});
